/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Selection_Create_TenantInputs */

const es_tenant_selection_create_tenant = /** @type {(inputs: Tenant_Selection_Create_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nueva empresa`)
};

const en_tenant_selection_create_tenant = /** @type {(inputs: Tenant_Selection_Create_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new organization`)
};

/**
* | output |
* | --- |
* | "Create new organization" |
*
* @param {Tenant_Selection_Create_TenantInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tenant_selection_create_tenant = /** @type {((inputs?: Tenant_Selection_Create_TenantInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Selection_Create_TenantInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tenant_selection_create_tenant(inputs)
	return en_tenant_selection_create_tenant(inputs)
});
export { tenant_selection_create_tenant as "tenant-selection.create_tenant" }